import { formatRoundedNumber } from '@/lib/formatUtils';

interface BottomBarProps {
  totalAmount: number;
}

export default function BottomBar({ totalAmount = 0 }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          <div className='flex items-center pr-6'>
            <span className='mr-2 font-medium'>Tổng tiền VND:</span>
            <span className='w-40 border-b text-right font-semibold'>{formatRoundedNumber(totalAmount)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
